import { ICaseBattleGame } from '@/utils/types/ICaseBattle';
import Case from '@/components/CaseBattles/Game/Case';
import GameBattleRollingStrip from '@/components/CaseBattles/Game/GameBattleRollingStrip';
import { useDragScroll } from '@/utils/hooks/use-drag-scroll';

interface Props {
    game: ICaseBattleGame;
}

const GameBattleCasesList = ({ game }: Props) => {
    // While the game is rolling, expand the strip to the full per-round
    // sequence and highlight the crate currently being opened.
    if (game.status === 'STARTED') {
        return <GameBattleRollingStrip game={game} />;
    }

    const grouped = new Map<number, number>();
    game.cases.forEach((c) => {
        grouped.set(c.caseId, (grouped.get(c.caseId) ?? 0) + 1);
    });

    const drag = useDragScroll();

    return (
        // Full-width block that fills the grid cell. Cases that overflow can be
        // dragged horizontally with LMB via useDragScroll. A plain click (no
        // movement past the browser's drag threshold) still bubbles to the
        // row's onClick=goView, so click-to-view keeps working.
        <div
            {...drag}
            className="no-scrollbar flex items-center gap-1.5 overflow-x-auto py-1 px-1 bg-layer_2 border border-stroke rounded-fl w-full min-w-0 cursor-grab active:cursor-grabbing"
        >
            {[...grouped.entries()].map(([caseId, count]) => (
                <Case
                    key={caseId}
                    id={caseId}
                    count={count}
                    tinted={game.status === 'FINISHED'}
                    mini
                />
            ))}
        </div>
    );
};

export default GameBattleCasesList;
